import * as Sentry from "@sentry/astro";

Sentry.init({
	dsn: import.meta.env.PUBLIC_SENTRY_DSN,
	// Adds request headers and IP for users, for more info visit:
	// https://docs.sentry.io/platforms/javascript/guides/astro/configuration/options/#sendDefaultPii
	sendDefaultPii: false,

	tracesSampleRate: 0, // disable tracing unless needed
	replaysSessionSampleRate: 0,
	replaysOnErrorSampleRate: 0,
});
